import * as React from 'react';
const Move = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-move", ...props },
    React.createElement("polyline", { points: "5 9 2 12 5 15" }),
    React.createElement("polyline", { points: "9 5 12 2 15 5" }),
    React.createElement("polyline", { points: "15 19 12 22 9 19" }),
    React.createElement("polyline", { points: "19 9 22 12 19 15" }),
    React.createElement("line", { x1: "2", y1: "12", x2: "22", y2: "12" }),
    React.createElement("line", { x1: "12", y1: "2", x2: "12", y2: "22" })));
export default Move;
//# sourceMappingURL=Move.js.map